import { useEffect, useMemo, useState } from "react";

export function useIsInViewport(ref, options = {}) {
  const [isIntersecting, setIsIntersecting] = useState(false);

  const observer = useMemo(() => {
    if (typeof window === "undefined") return null;

    return new IntersectionObserver(
      ([entry]) => setIsIntersecting(entry.isIntersecting),
      options
    );
  }, [options]);

  useEffect(() => {
    if (!ref.current || !observer) return;

    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref, observer]);

  return isIntersecting;
}
